
<br>
<div class="filtro justify-between border border-solid rounded border-gray-300 dark:border-gray-500 p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center">
  <div class="grid grid-cols-3 gap-4" [formGroup]="corteForm">
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Plaza de cobro</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="caseta"  (change)="getCarriles($event)">
        <option value="" disabled>Seleccione una caseta</option>
        <option *ngFor="let caseta of casetas" value="{{ caseta.id }}">{{ caseta.nombre}}</option>
      </select>
    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Reporte</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="tipo" (change)="setTipoReporte($event)">
        <option value="" disabled>Seleccione un Tipo de Reporte</option>
        <option value="1">Por turno</option>
        <option value="2">Mensual</option>
      </select>
    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Fecha</div>
      <input [type]="tipoReporte == 1 ? 'date' : 'month'" (blur)="buscarCortes()" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="fecha">
    </div>
    <div *ngIf="tipoReporte == 1">
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Turno: </div>
      <select (change)="buscarCortes()" formControlName="turno" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
          <option value="" selected disabled>Seleccionar turno</option>
          <option *ngFor="let turno of turnos" value="{{ turno.id }}">{{ turno.turno }}</option>
      </select>
    </div>

    <div *ngIf="tipoReporte == 1">
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">corte: </div>
        <select  formControlName="corte"  class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" multiple>
            <option value="" selected disabled>Seleccionar carril</option>
            <option *ngFor="let corte of cortes" value="{{ corte.id}}">{{ corte.carril.nombre }}:{{corte.usuario.nombre}}</option>
        </select>
    </div>

    <div class="grid grid-cols-2 gap-4 col-span-2">
      <button class="estilo-dark dark:text-gray-100 dark:bg-blue-600 " (click)="generarReporte()">Generar</button>
    </div>
    <div>
  </div>


</div>
<div class="bg-white dark:bg-gray-900/50 rounded-md w-full">
  <div class="p-2 overflow-x-auto h-96">
    <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
      <table class="w-full text-center text-gray-900 dark:text-gray-300" *ngIf="fallas && fallas.eventos && fallas.eventos.length >0">
        <thead>
          <tr class="border-b-2 border-gray-200 dark:border-gray-600 bg-gray-100 dark:bg-gray-900/50 text-gray-600 dark:text-gray-300">
            <th>{{ tipoReporte==1?"Carril" : "Fecha" }}</th>
            <th>Falla Lectura TAG</th>
            <th>Recarga No Reflejada</th>
            <th>No Baja Barrera</th>
            <th>Touch no Responde</th>
            <th>Boton Rojo Encendido</th>
            <th>Touch Escribe Otros Numero</th>
        </thead>

        <tbody>
          <tr *ngFor="let evento of fallas.eventos" class="border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900/50">
            <td class="p-2">{{ tipoReporte==1?evento.Carril: evento.Fecha }}</td>
            <td class="p-2">{{ evento.Falla_Lectura_TAG }}</td>
            <td class="p-2">{{ evento.Recarga_No_Reflejada }}</td>
            <td class="p-2">{{ evento.No_Baja_Barrera }}</td>
            <td class="p-2">{{ evento.Touch_no_Responde }}</td>
            <td class="p-2">{{ evento.Boton_Rojo_Encendido }}</td>
            <td class="p-2">{{ evento.Touch_Escribe_Otros_Numeros }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
